import { ReactNode } from "react";

import { SEARCH_FLOAT_AREA_CLASS_NAME } from "./const";

export const SearchFloatArea = ({ children }: { children: ReactNode }) => (
  <div className={SEARCH_FLOAT_AREA_CLASS_NAME()}>{children}</div>
);
